export enum EF360AlertTypesMapper {
  error = "error",
  warning = "warning",
  success = "success"
}

export const EF360AlertTypes: Record<
  EF360AlertTypesMapper,
  { color: string; icon: string }
> = {
  error: {
    color: "#ED1517",
    icon: "warning"
  },
  warning: {
    color: "#FFCE00",
    icon: "warning"
  },
  success: {
    color: "#066AFF",
    icon: "download_done"
  }
};

export enum ETipoDePerfil {
  None = 0,
  Cliente = 1,
  Representante = 2,
  Teste = 3,
  Franqueador = 4
}

export const ETipoApagarAreceber = [
  { nome: "A receber", _id: "false" },
  { nome: "A pagar", _id: "true" }
];
